var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.deviceData)?_c('apexchart',{attrs:{"type":"area","options":_vm.webAreaChart.chartOptions,"series":[{ name: 'Web Download', data: _vm.deviceData }],"height":"250"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }